import { create } from "zustand";

interface AnimationState {
  animatedIds: Set<string>;
  hasAnimated: (id: string) => boolean;
  setHasAnimated: (id: string) => void;
  reset: () => void;
}

export const useAnimationStore = create<AnimationState>((set, get) => ({
  animatedIds: new Set(),
  hasAnimated: (id: string) => get().animatedIds.has(id),
  setHasAnimated: (id: string) =>
    set((state) => {
      const newSet = new Set(state.animatedIds);
      newSet.add(id);
      return { animatedIds: newSet };
    }),
  reset: () => set({ animatedIds: new Set() }),
}));
